import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

import { FilterComponent } from '../filter.component';
import {FilterDefaultOptions} from '../filter-default-options.model';
import {Filter} from '../../../model/page';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss']
})
export class InputFieldComponent implements OnInit, FilterComponent {
  inputForm: FormGroup;

  @Input() data: FilterDefaultOptions;

  @Output() dispatchFilterValue: EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor() {}

  ngOnInit() {
    this.inputForm = new FormGroup({
      text: new FormControl('', [])
    });
  }

  get text(): AbstractControl {
    return this.inputForm.get('text');
  }

  onInputValidation(): void {
    const filter: Filter = {};
    filter.value = this.text.value.trim();
    filter.label = this.text.value.trim();
    filter.criteriaKey = this.data.criteriaKey;
    filter.criteriaLabel = this.data.criteriaLabel;
    this.dispatchFilterValue.emit(filter);
    this.text.reset();
  }
}
